<template>
  <div class="wrapper">
    <div id="view">
      <van-icon name="arrow-left" class="close" @click="goBack" v-if="isShowBack"/>
      <van-loading v-if="isShowLoad&&!isShowShjLogo" class="loading"/>
      <img src="../assets/iconImg/loading.gif" alt v-if="isShowLoad&&isShowShjLogo" class="loading">
      <img src="../assets/iconImg/loading-bg.png" alt v-if="isShowLoad&&isShowShjLogo" class="loading-bg">
      <span class="model-info" @click="showModelInfo" v-if="!isShowLoad&&isShowInfo">
        <i class="iconfont icon-zhanguanxinxi"></i>
      </span>
      <!-- <van-icon name="volume-o" id="playAudio" @click="playAudio"  v-if="!isShowLoad"/> -->
      <img src="../assets/iconImg/audio.png" id="playAudio" @click="playAudio" v-if="!isShowLoad && !isPlayAudio" v-show="$route.params.id === '5cd694824226897c042b83f5' || $route.params.id === '5cc2cd8442268958736ccfa7' ">
      <img src="../assets/iconImg/audio-loading.gif" id="stopAudio" @click="stopAudio" v-if="!isShowLoad && isPlayAudio" v-show="$route.params.id === '5cd694824226897c042b83f5' || $route.params.id === '5cc2cd8442268958736ccfa7'">
      <audio
        src="https://img3a.gemtec.ltd/1232.m4a"
        controls="controls"
        preload
        id="music"
        hidden 
      >
        <!-- <source src="http://ppbr9u7pg.bkt.clouddn.com/%E9%A9%B7%E9%A9%AC%E6%8B%96%E8%BD%A62.m4a"> -->
      </audio>
      <span class="try-on" @click="tryOn" v-if="isShowTryOn && !isShowLoad"><i class="iconfont icon-shidai"></i></span>
      <ul class="material-control">
        <li v-for="item in materialControl" @click="changeMaterial(item.id)" class="control-item">
          <img :src="item.material.thumbnail">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ModelView from "@/libs/GT3DViewer";
import { modelDtails } from "@/api/modelReq";
import { Share } from "@/api/wechat";
import { Loading, Icon, Dialog } from "vant";
export default {
  data() {
    return {
      isShowLoad: true,
      viewer: null,
      animationGroupsControl: [],
      materialControl: [],
      modelInfo: null,
      isShowInfo: true,
      isPlayAudio: false,
      isShowShjLogo: false,
      isShowTryOn: false
    };
  },

  components: {
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog
  },


  computed: {
    isShowBack: function() {
      if(window.__wxjs_environment === 'miniprogram') {
        return false
      } else {
        return true
      }
    }
  },
  // computed: {
  //   isShowTryon: function() {
  //      if(this.$route.params.isTryon === 'true') {
  //        return true
  //      } else {
  //        return false
  //      }
  //     // return true
  //   }
  // },

  mounted() {
    // this.viewer = new ModelView({
    //   element: document.getElementById("view"),
    //   url: `https://abc.gemtec.ltd/models/${this.$route.params.modelId}.gt3d`,
    // });
    // this.viewer.initSeat().then(res => {
    //     this.isShowLoad = false;
    //     if (res) {
    //       this.animationGroupsControl = res.output.animationGroups;
    //       this.materialControl = res.output.materialChanges;
    //     }
    // });
    modelDtails(this.$route.params.id).then(res => {
      this.viewer = new ModelView({
        element: document.getElementById("view"),
        url: `https://abc.gemtec.ltd/models/${res.modelId}.gt3d`
      });
      this.viewer.initSeat().then(res => {
        this.isShowLoad = false;
        if (res) {
          this.animationGroupsControl = res.output.animationGroups;
          this.materialControl = res.output.materialChanges;
        }
      });
      this.modelInfo = res;
      if ( res.tryOn ) {
        this.isShowTryOn = true
      }
      if (!res.content) {
        this.isShowInfo = false;
      }
      document.title = this.modelInfo.name;
      if (this.$isWeChat) {
        Share(
          this.modelInfo.name,
          this.modelInfo.thumbnail,
          this.modelInfo.content,
          window.location.href
        );
      }
    });
    console.log(this.$route.params.id);

    if(document.location.href.search('wxb6a37bfc27ad62e0')>0) {
      this.isShowShjLogo = true
    }
  },

  destroyed() {
    this.viewer.dispose();
    this.isShowShjLogo = false
  },

  methods: {
    changeMaterial(index) {
      this.viewer.changeMaterialWithIndex(index);
    },
    showModelInfo() {
      this.$dialog.alert({
        message: this.modelInfo.content,
        showConfirmButton: false,
        closeOnClickOverlay: true
      });
    },
    tryOn() {
      this.$router.push({
        path: `/try-on/${this.modelInfo.id}`
      });
    },
    playAudio() {
      var audio = document.getElementById("music"); 
      if (audio !== null) {
          audio.play();
          this.isPlayAudio = true;
      }
    },
    stopAudio() {
      var audio = document.getElementById("music"); 
      if (audio !== null) {
        audio.pause();
        this.isPlayAudio = false;
      }
    },
    goBack() {
      window.history.back()
    }
  }
};
</script>

<style scoped lang="less">
// @media screen and (orientation: portrait) {
//   .wrapper {
//     position: absolute;
//     width: 100vh;
//     height: 100vw;
//     top: 0;
//     left: 100vw;
//     -webkit-transform: rotate(90deg);
//     -moz-transform: rotate(90deg);
//     -ms-transform: rotate(90deg);
//     transform: rotate(90deg);
//     transform-origin: 0% 0%;
//   }
// }

// @media screen and (orientation: landscape) {
//   .wrapper {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100vw;
//     height: 100vh;
//   }
// }
.wrapper {
  width: 100vw;
  height: 100vh;
  background: url("http://img.tutubox.cn/gemModelViewBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  #view {
    width: 100%;
    height: 100%;
    position: relative;
    .close {
      position: absolute;
      top: 10px;
      left: 10px;
      font-size: 25px;
      color: #fff;
    }
    .loading {
      width: 60%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      // background-color: rgba(192,192,192);
      z-index: 99;
    }
    .loading-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    #playAudio {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 25px;   
    }
    #stopAudio{
      position: absolute;
      top: 20px;
      right: 20px;
      width: 25px;     
    }
    .model-info {
      position: absolute;
      top: 20px;
      right: 20px;
      color: #fff;
      display: inline-block;
      width: 35px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      border-radius: 50%;
      background-color: rgba(128, 138, 135, 0.5);
      .iconfont {
        font-size: 20px;
      }
    }
    .try-on {
      position: absolute;
      top: 60px;
      right: 20px;
      color: #fff;
      display: inline-block;
      width: 35px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      border-radius: 50%;
      background-color: rgba(128, 138, 135, 0.5);
      .iconfont {
        font-size: 20px;
      }
    }
    .material-control {
      display: flex;
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translate(-50%);
      .control-item {
        margin-right: 20px;
        img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>